import { preload, goto, redirect } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import _ from 'lodash';
import App from 'app/store/components/glowforge/order-page';
import * as gfStoreApi from 'app/store/api/glowforge-store-api';
import features from 'app/common/containers/features';
import { fetchAddressStates, fetchReferral } from 'app/common/api/common-api';
import { getStringsForPage, getMarkdownStringsForPage } from 'app/common/selectors/page';
import { cancelAddressVerify, confirmAddressVerify } from 'app/common/actions/common';
import * as commonSelectors from 'app/common/selectors/common';
import * as shippingSelectors from 'app/selectors/shipping';
import * as orderPageSelectors from 'app/store/selectors/glowforge-order-page';

// Product ID in format pro_id;kit_id;accessory_id
// Need to be converted into pro_id:1,kit_id:1,accessory_id:1
const productToParam = id => `${id.split(';').join(':1,')}:1`;

const extractPermalinkProductsParam = (values, products) => {
  const product = Object.values(products).filter(p => p.id.toString() === values.productPicker)[0];
  const param = [productToParam(product.shopifyIds)];
  if (values.airFilter) {
    param.push(productToParam(products.air.shopifyIds));
  }
  return param.join(',');
};

const extractPermalinkReferralParam = (values, products, referral) => {
  if (referral == null || (referral.code == null && referral.pl == null)) {
    return '';
  }

  let discount = null;
  Object.keys(products).forEach((key) => {
    const product = products[key];
    if (product.id.toString() === values.productPicker) {
      if (referral.code) {
        discount = product.referralDiscount;
      } else {
        discount = referral.pl[key];
      }
    }
  });

  if (discount == null) {
    return '';
  }

  let paramString = `?discount=${discount}`;

  if (referral.code) {
    paramString += `&attributes[Referral Code]=${referral.code}`;
  }

  if (referral.pl) {
    paramString += `&attributes[Promo Link]=${referral.pl.id}`;
  }

  return paramString;
};

const mapStateToProps = (state, route) => {
  const backorderable = _.get(route, 'location.query.backorderable') === 'true';
  return {
    className: 'GlowforgeOrderPage',
    pageInfo: orderPageSelectors.getOrderPageInfo(state),
    pageIcons: orderPageSelectors.getOrderPageIcons(state),
    pageStrings: getStringsForPage(_.get(state, 'glowforgeStore.page.fields')),
    pageMarkdown: getMarkdownStringsForPage(_.get(state, 'glowforgeStore.page.fields')),
    referralInfo: orderPageSelectors.getReferralInfo(state),
    initialValues: {
      productPicker: backorderable
        ? orderPageSelectors.getProId(state).toString()
        : orderPageSelectors.getSelectedProductId(state),
      airFilter: orderPageSelectors.airFilterSelectedByDefault(state),
    },
    subTotal: orderPageSelectors.getSubTotal(state),
    products: _.get(state, 'glowforgeStore.products'),
    selectedProduct: orderPageSelectors.getSelectedProductId(state),
    isAirFilterSelected: orderPageSelectors.isAirFilterSelected(state),
    isSelectedBackordered: orderPageSelectors.isSelectedBackordered(state),
    isIpAddressInUS: commonSelectors.isIpAddressInUS(state),
    expressShippingEnabled: orderPageSelectors.expressShippingEnabled(state),
    shippingInfoMarkdown: orderPageSelectors.getShippingInfoMarkdown(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return ({
    submitOrderToShopify: (values, products, referralInfo) => {
      const productsParam = extractPermalinkProductsParam(values, products);
      const referralParam = extractPermalinkReferralParam(values, products, referralInfo);
      const uri = `${window.sharedEnv.SHOPIFY_URL}/cart/${productsParam}${referralParam}`;
      window.location = encodeURI(uri);
    },
    goToRoot: () => dispatch(goto('/order')),
  });
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch }) => {
    const requests = [
      dispatch(gfStoreApi.fetchProducts()),
      dispatch(fetchReferral()),
    ];

    requests.push(dispatch(gfStoreApi.fetchGlowforgeOrderPageLite()));

    return Promise.all(requests);
  })(App),
);

export default features(AppContainer);



// WEBPACK FOOTER //
// ./app/store/containers/glowforge/order-page.js